import * as React from "react";
import {useEffect} from "react";
import {withNavigation} from "../navigation/navigation";
import DataTable from 'react-data-table-component';
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {Box, Button, Stack, Typography, Breadcrumbs} from "@mui/material";
import {usePoliceMode} from "../policeMode/hook/usePoliceMode";
import StarIcon from "@mui/icons-material/StarBorder";
import SwapVertIcon from "@mui/icons-material/FilterList";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {useOrderHistory} from "./hooks/useOrderHistory";
import {withOrderHistoryContext} from "./state/orderHistoryContext";
import {useNavigate} from "react-router-dom";
import {useSubmit} from "./hooks/useSubmit";
import QuoteHistory from "./QuoteHistory";
import CircularProgress from "@mui/material/CircularProgress";


const OrderHistory = ({setShowNav}) => {
    const {mode} = useDarkMode();
    const {police} = usePoliceMode();
    const {history, loading} = useOrderHistory(1);
    console.log('History:', history)
    const { createOrderFromOld } = useSubmit();
    const navigate = useNavigate();
    useEffect(() => {
        setShowNav(false);
    }, []);

    const breadcrumbs = [
        <Typography
            className={'breadcrumbs'}
            variant={'body2'}
            onClick={() => navigate('/')}
            style={{color: mode.settings.breadcrumbColor1}}>
            Accueil
        </Typography>,
        <Typography variant={'body2'} style={{color: mode.settings.textColor3}}>
            Mes commandes
        </Typography>,
    ];



    const columns = [
        {
            name: 'Mes commandes',
            selector: row => row.order,
            cell: ((row) => {
                return (
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} width={'100%'}
                           flexWrap={'wrap'}
                           gap={'5px'}
                    >
                        <Stack direction={'row'} alignItems={'center'} gap={1}>
                            <Box
                                sx={{
                                    backgroundColor: "#F2F4F8",
                                    borderRadius: "50%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "40px", // Adjust the size as needed
                                    height: "40px", // Adjust the size as needed
                                }}
                            >
                                <img src={`/assets/icon/${row.productCategory}.png`} alt="service" style={{width: '27px'}}/>
                            </Box>
                            <Typography variant={'subtitle6'} color={mode.settings.textColor3}>{row.productName}</Typography>
                        </Stack>

                        <Button
                            className="btn-gradient"
                            variant="contained"
                            size="small"
                            sx={{width: '200px !important', borderRadius : '15px !important'}}
                            aria-label={"Description"}
                            onClick={ async  () => {
                                const orderId = await createOrderFromOld(row.id);
                                if (orderId) {
                                    navigate(`/order-detail/${orderId}`)
                                }
                            }}
                        >
                            <Typography variant={'subtitle6'}>Recommander</Typography>
                        </Button>
                    </Stack>

                )
            })
        },
        {
            name: 'Etat Livraison',
            selector: row => row.delivery,
            cell: ((row) => {
                return (
                    <Typography variant={'subtitle6'} color={mode.settings.textColor3}>{row.delivery}</Typography>
                )
            }),
            maxWidth : '300px'
        },
        {
            name: 'Etat paiement',
            selector: row => row.payment,
            sortable: true,
            cell: ((row) => {
                return (
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
                        <Button
                            variant="contained"
                            size="small"
                            sx={{borderRadius : '15px !important',
                                backgroundColor : row.payment == 'Payé' ? '#6BC46A' : '#DD809D',
                                minWidth : '188px'
                            }}
                            aria-label={"Description"}
                        >
                            <Typography variant={'subtitle6'} >{row.payment}</Typography>
                        </Button>
                        <KeyboardArrowRightIcon sx={{marginLeft : row.payment == 'Payé' ? '98px' : '70px', cursor : 'pointer', color: mode.settings.textColor3}}
                            onClick={() => {
                                navigate(`/order-detail/${row.id}`)
                            }}
                        />
                    </Stack>

                )
            }),
            maxWidth : '300px'
        },
    ];

    const data = [
        {
            id: 1,
            order: 'Livraison des courses 1',
            delivery: 'En cours de livraison',
            payment: 'Payé'
        },
        {
            id: 1,
            order: 'Livraison des courses 2',
            delivery: 'En cours de livraison',
            payment: 'Non Payé'
        },
    ]

    const customStyles = {
        // rows: {
        //     style: {
        //         fontFamily: police.normalMode ? 'Roboto' : 'Comic Sans MS'
        //     },
        // },
        headCells: {
            style: {
                color : mode.settings.textColor9,
                fontFamily: police.normalMode ? 'Roboto' : 'Dyslexic',
                fontSize : '18px',
                backgroundColor : mode.settings.cardBackgroundColor,
            },
        },
        cells: {
            style: {
                color : mode.settings.textColor9,
                fontFamily: police.normalMode ? 'Roboto' : 'Dyslexic',
                backgroundColor : mode.settings.cardBackgroundColor,
            },
        },
        pagination: {
            style: {
                color : mode.settings.textColor9,
                fontFamily: police.normalMode ? 'Roboto' : 'Dyslexic',
                backgroundColor : mode.settings.cardBackgroundColor,
            },
        },
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Résultat par page',
        rangeSeparatorText: 'sur',
        selectAllRowsItem: false,
        selectAllRowsItemText: 'Todos',
    };

    if (loading) return <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '50vh',
        }}
    >
        <CircularProgress size={50}/>
    </Box>;

    return (
        !loading && <Box sx={{width : '100% '}}>
            <Breadcrumbs
                separator="›"
                aria-label="navigation"
                style={{color: mode.settings.textColor3, marginTop : '15px'}}>
                {breadcrumbs}
            </Breadcrumbs>
            <Typography
                variant="h5"
                sx={{
                    mt: {xs : 2 , md : 2, lg : 2},
                    mb: {xs : 4 , md : 4, lg : 2},
                    textAlign : {xs : 'center' , md : 'center', lg : 'left'},
                }}
                style={{color: mode.settings.textColor3}}
                id={'anchor0'}
            >
                {' '}
                Suivi de mes commandes{' '}

            </Typography>
            <DataTable
                columns={columns}
                data={history.history}
                customStyles={customStyles}
                sortIcon = {<SwapVertIcon style={{fontSize: '50px', marginTop :'5px', marginLeft:'20px', width: '35px', height : 'auto'}}/>}
                pagination
                paginationComponentOptions={paginationComponentOptions}
                noDataComponent={<div>Vous n'avez pas encore de commande</div>}
            />
            {
                history.quotes && <QuoteHistory history={history.quotes.filter(item => item !== undefined)}/>
            }

        </Box>

    );
}

export default withNavigation(withOrderHistoryContext(OrderHistory));
